import React, { type ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";
import images from "@/utils/images";

import "./styles.scss";

export const BrandedHeader = ({ className }: ComponentProps<"header">) => {
  return (
    <header className={cn("header-container tw:!relative tw:shadow-sm", className)}>
      <div className="header-container-inner d-flex tw:justify-center">
        <img
          alt="aptihealth logo with transforming behavioral healthcare tagline"
          className="apti-logo-w-tagline tw:mx-3 tw:py-2"
          src={images("./common/apti_logo_w_tagline_v2.svg")}
        />
      </div>
    </header>
  );
};
